module.exports = __webpack_public_path__ + "static/img/bg1.d5c91f78.png";